import React, { useEffect } from "react";
import { Checkbox, Col, Form, FormInstance, Input, Row } from "antd";
import { UserDataProps } from "../../../interfaces/interfaces";
import { CheckboxChangeEvent } from "antd/es/checkbox";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";

interface Props {
  values: UserDataProps;
  setValues: React.Dispatch<React.SetStateAction<UserDataProps>>;
  form: FormInstance<any>;
  edit?: boolean;
}

export const UserForm = ({ values, setValues, form, edit }: Props) => {
  useEffect(() => {
    form.setFieldsValue(values);
  }, [form, values]);

  const handleChange = (
    event:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    event.preventDefault();
    setValues((prev) => {
      return {
        ...prev,
        [event.target.name]: event.target.value,
      };
    });
  };

  const handleChangeCheckbox = (event: CheckboxChangeEvent) => {
    event.preventDefault();
    setValues((prev) => {
      return {
        ...prev,
        [`${event.target.name}`]: event.target.checked,
      };
    });
  };
  return (
    <>
      <Form layout="vertical" initialValues={values} form={form}>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              label="Name"
              name="Name"
              rules={[{ required: true, message: "Input user name" }]}
            >
              <Input
                name="Name"
                placeholder="Name"
                value={values.Name}
                onChange={handleChange}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="Username"
              name="UserName"
              rules={[
                { required: true, message: "Username" },
                { type: "email" },
              ]}
            >
              <Input
                name="UserName"
                placeholder="Username"
                value={values.UserName}
                onChange={handleChange}
              />
            </Form.Item>
          </Col>
          {!edit ? (
            <>
              <Col span={12}>
                <Form.Item
                  label="Password"
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: "Please provide Password",
                    },
                  ]}
                >
                  <Input.Password
                    placeholder="Password"
                    name="password"
                    value={values.Password}
                    onChange={handleChange}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="password2"
                  validateTrigger="onBlur"
                  label="Repeat new password"
                  className="collections-form__form-item"
                  rules={[
                    {
                      required: true,
                      message: "Please confirm your password",
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("password") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error(
                            "The new password that you entered do not match!"
                          )
                        );
                      },
                    }),
                  ]}
                >
                  <Input.Password
                    placeholder="Repeat new password"
                    iconRender={(visible) =>
                      visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                    }
                  />
                </Form.Item>
              </Col>
            </>
          ) : (
            <Col span={24}>
              <Form.Item className="align-center" valuePropName="checked">
                <Checkbox
                  name="IsActive"
                  checked={values.IsActive}
                  onChange={handleChangeCheckbox}
                >
                  Active
                </Checkbox>
              </Form.Item>
            </Col>
          )}
        </Row>
      </Form>
    </>
  );
};
